/**
 * en-GB messages added by Phase 4 task p4/gap-web (Sign In App parity gaps, spec sections 2.1 and 2.2).
 * Flat keys, `{name}` placeholders, merged into enGB by ./index.ts.
 */
export const gapWebEnGB = {
    // Evacuation reports list
    'evac.reports.col.startedBy': 'Started by',
    'evac.reports.col.completedBy': 'Completed by',
    'evac.reports.col.result': 'Result',
    'evac.reports.result.allAccounted': 'All accounted for',
    'evac.reports.result.unaccounted': '{count} unaccounted',
    // Today board actions
    'today.preregister.button': 'Pre-register',
    'today.manageGroup.button': 'Manage group',
    'today.manageGroup.for': 'Manage group {name}',
    // Account menu
    'shell.gettingStarted': 'Getting started',
    'shell.whatsNew': "What's new",
    'shell.support': 'Support',
    'shell.support.subject': 'CloudSign support',
    // What's new page
    'whatsNew.title': "What's new",
    'whatsNew.description': 'The latest changes to CloudSign.',
    'whatsNew.version': 'Version {version}',
    'whatsNew.date': 'Released {date}',
    // Platform setting core.support
    'settings.core.support': 'Support',
    'settings.core.support.email': 'Support email address, behind the Support link in the account menu (empty = no link)',
};
//# sourceMappingURL=gap-web.js.map